export class AvailableProductLocaleResponse {
  public country: Array<string>;
  public language: Array<string>;

  constructor(data?: any | null) {
    this.country = [...(data?.country || [])];
    this.language = [...(data?.language || [])];
  }
}
